<template>
  <CCard>
    <CCardHeader><h2>ユーザ詳細</h2></CCardHeader>
    <CCardBody>
      <CAlert color="info">
        管理権限を持つ利用者は、業務上必要な社員情報と個人連絡先を確認・代理更新できます。電話番号、住所、SlackメンバーIDは本人も「個人設定」から変更できます。パスワードは表示しません。
      </CAlert>
      <CAlert v-if="errorMessage" color="danger">{{ errorMessage }}</CAlert>
      <div v-if="loading" class="text-center py-5">
        <CSpinner color="primary"/> 読み込んでいます
      </div>

      <CRow v-else-if="items">
        <CCol sm="12" lg="8">
          <table class="table table-bordered">
            <tbody>
              <tr><th>社員番号</th><td>{{ items.employee_id }}</td></tr>
              <tr><th>氏名</th><td>{{ items.name }}</td></tr>
              <tr><th>所属部署</th><td>{{ items.department_name || '' }}</td></tr>
              <tr><th>電話番号</th><td>{{ items.telephone || '' }}</td></tr>
              <tr><th>住所</th><td>{{ items.address || '' }}</td></tr>
              <tr><th>ログインE-Mail</th><td>{{ items.email }}</td></tr>
              <tr><th>入社年月日</th><td>{{ formatDate(items.hire_date) }}</td></tr>
              <tr>
                <th>役割</th>
                <td>
                  <CBadge
                    v-for="roleName in roleNames"
                    :key="roleName"
                    color="info"
                    class="mr-1 mb-1"
                  >
                    {{ roleName }}
                  </CBadge>
                  <span v-if="!roleNames.length" class="text-muted">未設定</span>
                </td>
              </tr>
              <tr><th>申請承認者</th><td>{{ items.approver_flg === true ? '有' : '無' }}</td></tr>
              <tr><th>週稼働日数（有休付与区分）</th><td>{{ workingDaysLabel(items.working_days) }}</td></tr>
              <tr><th>有給日数</th><td>{{ unitValue(items.paid_days, '日') }}</td></tr>
              <tr><th>代休日数</th><td>{{ unitValue(items.comp_days, '日') }}</td></tr>
              <tr><th>今期有休消化日数</th><td>{{ unitValue(items.paid_days_used, '日') }}</td></tr>
              <tr><th>有給付与月</th><td>{{ unitValue(items.paid_days_add, '月') }}</td></tr>
              <tr><th>固定内残業</th><td>{{ items.fixed_over_time }}</td></tr>
              <tr><th>SlackメンバーID</th><td>{{ items.slack_id || '' }}</td></tr>
            </tbody>
          </table>
        </CCol>
      </CRow>

      <CRow class="mt-3 align-items-center">
        <CCol class="text-start">
          <button class="btn btn-secondary" @click="goBack">戻る</button>
        </CCol>
        <CCol class="text-center">
          <button v-if="items" class="btn btn-info" @click="goEdit">編集</button>
        </CCol>
        <CCol></CCol>
      </CRow>
    </CCardBody>
  </CCard>
</template>

<script>
import ConstList from './ConstList'
import axios from 'axios'

export default {
  name: 'Info',
  data () {
    return {
      items: null,
      id: null,
      loading: true,
      errorMessage: '',
      list: ConstList.ROUTE_LIST,
      updateTop: ConstList.UPDATE_TOP
    }
  },
  computed: {
    roleNames () {
      return this.items && Array.isArray(this.items.role_names)
        ? this.items.role_names
        : []
    }
  },
  mounted () {
    this.loadUser()
  },
  methods: {
    loadUser () {
      const parsedId = Number(this.$route.params.id)
      if (!Number.isInteger(parsedId) || parsedId <= 0) {
        this.loading = false
        this.errorMessage = 'ユーザーを特定できませんでした。ユーザー一覧から開き直してください。'
        return
      }
      this.id = parsedId
      axios.get(process.env.VUE_APP_API_ORIGIN + '/users/' + this.id)
        .then(response => {
          if (!response.data || typeof response.data !== 'object') {
            throw new Error('ユーザー情報を読み取れませんでした。ユーザー一覧から開き直してください。')
          }
          this.items = response.data
        })
        .catch(error => {
          this.items = null
          this.errorMessage = this.resolveError(error, 'ユーザー情報を取得できませんでした。')
        })
        .finally(() => { this.loading = false })
    },
    goBack () {
      this.$router.push({ name: this.list })
    },
    goEdit () {
      this.$router.push({ name: this.updateTop, params: { id: this.items.id } })
    },
    formatDate (dateStr) {
      if (!dateStr || dateStr === 'null') return ''
      const parts = String(dateStr).split('-')
      return parts.length === 3
        ? `${parts[0]}/${parts[1]}/${parts[2]}`
        : String(dateStr)
    },
    workingDaysLabel (value) {
      const days = Number(value)
      if (!Number.isFinite(days)) return ''
      if (days === 5) return '通常(週5日)'
      if (days === 0) return '有休付与無し'
      return `週${days}日`
    },
    unitValue (value, unit) {
      return value == null || value === '' ? '' : `${value}${unit}`
    },
    resolveError (error, fallback) {
      const data = error && error.response && error.response.data
      if (data && typeof data === 'object') return data.message || fallback
      if (typeof data === 'string' && data) return data
      // axiosが付ける英語のmessage（Network Error など）は画面へ出さない。
      // 画面側が自分で投げたErrorの日本語だけを通す。
      if (error && !error.isAxiosError && error.message) return error.message
      return fallback
    }
  }
}
</script>

<style scoped>
th { width: 34%; color: #334155; }
td { word-break: break-word; overflow-wrap: anywhere; }
</style>
